'use client'

import { useAnimateOnVisible } from '@hooks/useAnimateOnVisible'
import { BrandHubDescriptionMock } from '@components/BrandHub/BrandHubMock'
import styles from './BrandHubTitle.module.scss'

export const BrandHubTitle = () => {
  const { ref, animationClassName } = useAnimateOnVisible<HTMLParagraphElement>()
  return (
    <p ref={ref} className={`${styles.brandHubTitle} ${animationClassName}`}>
      {BrandHubDescriptionMock.title}
    </p>
  )
}

export const BrandHubDescription = () => {
  const { ref, animationClassName } = useAnimateOnVisible<HTMLParagraphElement>()
  return (
    <p ref={ref} className={`${styles.brandHubDescription} ${animationClassName}`}>
      {BrandHubDescriptionMock.description}
    </p>
  )
}
